<template>
  <div>
    <v-register-form
      :small-screen="true"
      @authenticated="(payload) => {$emit('authenticated', payload)}"
    />
  </div>
</template>

<script>
import RegisterForm from '@/common/components/auth/RegisterForm.vue';

export default {
  name: 'RegisterUser',
  components: {
    'v-register-form': RegisterForm,
  },
};
</script>
